import { BaseDto } from './base.dto';
import { PrintConfigurationDto } from './printConfiguration.dto';
import { PrintTemplateSectionDto } from './printTemplateSection.dto';
export class PrintConfigurationTemplateSectionSettingDto extends BaseDto{

    printConfiguration: PrintConfigurationDto;
    

    printTemplateSection: PrintTemplateSectionDto;


    enabled: boolean;

    printingMetadataValues: any;


    printingFormattingValues: any;
}